import {PORT} from "../config/config";

export const getSumCostBeforeSellNoRepair = (car) => {
    // ทุนรถก่อนขาย ที่ ไม่รวม => ราคารถ , vatรถ และไม่รวมค่าซ่อมรถ
    let cost_operation = car.cost_operation;
    let cost_service = car.cost_service;
    let cost_transport = car.cost_transport;
    let cost_porobor_lan = car.cost_porobor_lan;
    let cost_bangkhab_phasi_lan = car.cost_bangkhab_phasi_lan;
    let cost_bangkhab_xon_lan = car.cost_bangkhab_xon_lan;
    let cost_check_ton = car.cost_check_ton;
    let cost_inspection_lan = car.cost_inspection_lan;
    let car_cost_commissions = car.car_cost_commissions
    let car_cost_act = car.car_cost_act
    let car_cost_tax = car.car_cost_tax

    let car_cost_expenses_other = Number(car.car_cost_expenses_other || 0) + Number(car.car_cost_other || 0)
    let car_cost_other_sum = car_cost_expenses_other

    // at
    car_cost_other_sum += Number(cost_operation || 0);
    car_cost_other_sum += Number(cost_service || 0);
    car_cost_other_sum += Number(cost_transport || 0);
    car_cost_other_sum += Number(cost_porobor_lan || 0);
    car_cost_other_sum += Number(cost_bangkhab_phasi_lan || 0);
    car_cost_other_sum += Number(cost_bangkhab_xon_lan || 0);
    car_cost_other_sum += Number(cost_check_ton || 0);
    car_cost_other_sum += Number(cost_inspection_lan || 0);
    //
    car_cost_other_sum += Number(car_cost_commissions || 0);
    car_cost_other_sum += Number(car_cost_act || 0);
    car_cost_other_sum += Number(car_cost_tax || 0);

    return car_cost_other_sum
}


export const getSumCostBeforeSell = (car) => {
    // ค่าใช้จ่ายซื้อรถเข้าและรวมค่าซ่อม ไม่รวมราคารถ+vatรถ
    // รวมค่าใช้จ่ายในการขาย(ของรถ) (car_cost_expenses_sell) ด้วย
    let car_cost_repair = car.car_cost_repair;
    let car_cost_other_sum = getSumCostBeforeSellNoRepair(car)
    car_cost_other_sum += Number(car_cost_repair  || 0);
    // เพิ่มค่าใช้จ่ายในการขายจากตาราง expense (expense_type_id = 4)
    //car_cost_other_sum += Number(car.car_cost_expenses_sell || 0);
    return car_cost_other_sum
}

// ใช้เฉพาะตอนยังไม่ขายเท่านั้น
export const getProfitBeforeSell = (car) => {
    let car_cost_other_sum = getSumCostBeforeSellNoRepair(car)
    // 9043 คำนวณกำไร ราคาขาย - รวมทุนที่ไม่รวมภาษีซื้อ 26-2-68
    let profit = Number(car.car_sale_price || 0) - (Number(car.car_cost || 0) + Number(car.vat_buy || 0) + car_cost_other_sum + Number(car.car_cost_repair || 0) + Number(car.car_cost_expenses_sell || 0))
    if(PORT===9043){
        profit = Number(car.car_sale_price || 0) - (Number(car.car_cost || 0) + car_cost_other_sum + Number(car.car_cost_repair || 0))
    }
    return profit
}

// ส่วนต่างเงินคืนลูกค้า => รายรับของเต็นท์
export const getRefundDifference = (car) => {
    const car_excess_amount = car.car_excess_amount
    const customer_cash = car.customer_cash
    let refund_difference = 0
    let refund_cash = 0
    if(car_excess_amount > 0){
        // เงินคืนลูกค้า
        //refund_type = 1 คืนเงินเต็ม
        //refund_type = 2 ไม่คืนเงิน
        //refund_type = 3 คืนเงินบางส่วน
        if(car.refund_type === 0){
            refund_cash = 0
        }else if(car.refund_type === 1){
            refund_cash = car.customer_cash
        }else if(car.refund_type === 2){
            refund_cash = 0
        }else if(car.refund_type === 3){
            refund_cash = car.refund_inpart
        }
        refund_difference = customer_cash - refund_cash
    }
    return {
        refund_difference, refund_cash
    }
}


//ส่วนการขาย
export const getSumCostAfterSell = (car) => {
    //ค่าใช้จ่ายการขาย ทางเต็นท์รับผิดชอบ
    let car_external_commission = car.car_external_commission;
    let sales_commission = car.sales_commission;
    let additional_commission = car.additional_commission;
    let advertising_cost = car.advertising_cost;
    let delivery_fee = car.delivery_fee;
    let finance_fee = car.finance_fee;
    let promotion_fee = car.promotion_fee;
    let transfer_fee = car.transfer_fee;
    let cost_after_sales_service = car.cost_after_sales_service;
    let cost_phra = car.cost_phra;
    let cost_vat_and_property_tax = car.cost_vat_and_property_tax;
    let land_tax_and_sign_tax_and_others = car.land_tax_and_sign_tax_and_others;
    let oem_at = car.oem_at;

    let car_cost_after_sell = Number(car_external_commission || 0) + Number(sales_commission || 0) + Number(additional_commission || 0)
                            + Number(advertising_cost || 0) + Number(delivery_fee || 0) + Number(finance_fee || 0) + Number(promotion_fee || 0)
                            + Number(transfer_fee || 0) + Number(cost_after_sales_service || 0) + Number(cost_phra || 0) + Number(cost_vat_and_property_tax || 0)
                            + Number(land_tax_and_sign_tax_and_others || 0) + Number(oem_at || 0);

    // เพิ่มค่าใช้จ่ายในการขาย(ของรถ)จากตาราง expense (expense_type_id = 4)
    car_cost_after_sell += Number(car.car_cost_expenses_sell || 0);

    return car_cost_after_sell

}

export const getSumCostFinanceAfterSell = (car_sell) => {
    // ค่าใช้จ่ายจากไฟแนนซ์ (บันทึกกรณีจ่ายแล้ว)
    let finance_pa = car_sell.finance_pa
    let finance_car_insurance = car_sell.finance_car_insurance
    let finance_ew = car_sell.finance_ew
    let finance_pay_advance = car_sell.finance_pay_advance
    let finance_health_insurance = car_sell.finance_health_insurance
    let finance_document_fee = car_sell.finance_document_fee
    let finance_transfer_fee = car_sell.finance_transfer_fee
    let finance_stamp_fee = car_sell.finance_stamp_fee

    return Number(finance_pa || 0) + Number(finance_car_insurance || 0) + Number(finance_ew || 0) + Number(finance_pay_advance || 0) + Number(finance_health_insurance || 0) + Number(finance_document_fee || 0) + Number(finance_transfer_fee || 0) + Number(finance_stamp_fee || 0)
}



export const getSumCostSellPayByCustomer = (car_sell) => {
    //รวมค่าใช้จ่ายตอนขาย ที่ลูกค้าต้องจ่ายเพิ่มเอง
    //เกิดขึ้นแค่กรณี ยอดจัดเกิน
    let car_excess_amount = car_sell.car_excess_amount
    let car_excess_amount_use = 0
    if(car_excess_amount > 0) {
        car_excess_amount_use =  car_sell.debt_insurance_amount + car_sell.cost_sell_act + car_sell.total_outof_discount

        if(car_sell.insurance_buy === 'ซื้อเอง'){
            // ราคาประกันรถยนต์
            if (car_sell.finance_car_insurance === 0) {
                car_excess_amount_use += car_sell.insurance_price
            }
        }

        if(car_sell.insurance_pa_buy === 'PA ซื้อเอง'){

            if (car_sell.finance_pa === 0) {
                car_excess_amount_use += car_sell.insurance_pa
            }
        }

        if (car_sell.finance_ew === 0) {
            car_excess_amount_use += car_sell.gearbox_amount
        }

        if (car_sell.finance_pay_advance === 0) {
            car_excess_amount_use += car_sell.pay_advance_finance
        }

        car_excess_amount_use += car_sell.cost_finance
        // if (car_excess_amount_use+car_sell.cost_finance <= car_excess_amount) {
        //}

    }

    return car_excess_amount_use

}

